import { Pipe, PipeTransform } from '@angular/core';

const CONFIDENCE_LEVELS: { value: number; label: string }[] = [
  { value: 90, label: 'Certain' },
  { value: 70, label: 'High' },
  { value: 50, label: 'Moderate' },
  { value: 30, label: 'Low' },
];

@Pipe({
  name: 'confidenceLabel',
  standalone: true,
})
export class ConfidenceLabelPipe implements PipeTransform {
  transform(confidence: number): string {
    const found = CONFIDENCE_LEVELS.find(c => c.value === confidence);
    return found ? found.label : `${confidence}%`;
  }
}
